<template>
  <myhead @next="next" @lookmore="more">{{$route.meta.title}}</myhead>
  <img src="@/assets/img/logo.png" v-if="step==1" class="width45 pad20 mt30 auto" alt="">
  <div class="myField mb40" v-if="step==1">
    <van-field v-model="idcard" label="身份证号:" placeholder="请输入身份证号" />
    <van-field v-model="mobile" label="手机号:" placeholder="请输入11位手机号" />
    <div class="flex">
      <div class="width65"><van-field v-model="smscode" placeholder="请填写验证码" label="验证码:" style="padding-right:10px"/></div>
      <div><send-sms :mobile="mobile" :typeid="3">获取验证码</send-sms></div>
    </div>
  </div>
  <div class="myField mt30 vh40" v-if="step==2">
    <div>
      <van-field v-model="password" type="password" label="设置密码:" placeholder="请填写密码" />
      <p class="Cred ml120 mb15 size12">仅支持数字、字母、下划线</p>
      <van-field v-model="cpassword" type="password" label="确认密码:" placeholder="请确认密码" />
      <!-- <p class="Cred ml120 mb15 size12">两次输入密码不一致，请重新输入</p> -->
    </div>
  </div>
  <div class="center" v-if="step==3">
    <div class="BGon Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32"><van-icon name="success" /></div>
    <p class="b500 mt20 mb40 size18">密码设置完成</p>
    <div class="pad40"><van-button block type="primary" round @click="$router.replace({path:'/login'})">去登录</van-button></div>
  </div>
  <div class="pad25" v-if="step<3">
    <van-button block type="primary" round @click="next">确认</van-button>
    <div class="flex between Con mt20">
      <div @click="$router.push({path:'/register'})">注册账号</div>
    </div>
  </div>
</template>

<script>
import SendSms from "@/components/SendSms.vue";
export default {
  components:{'send-sms':SendSms
  },
  data:(()=>{
    return {
      idcard:'',
      mobile:'',
      smscode:'',

      password:'',
      cpassword:'',

      step:1
    }
  }),
  methods:{
    next(){
      if(this.step==1){
        this.ajax.post("users/setpassidcard",{ mobile:this.mobile, idcard:this.idcard, smscode:this.smscode}).then(()=>{
          this.step=2;
        })
      }else if(this.step==2){
        this.ajax.post("users/setpass",{ mobile:this.mobile,smscode:this.smscode,password:this.password,cpassword:this.cpassword }).then(()=>{
          this.step=3
        })
      }
    }
  },
  created(){
  }
}
</script>

<style>
</style>